// @ts-nocheck
import axios from "axios";
import moment from "moment-timezone";
import SpecialDayImg from "../assets/image/special-day.png";
import store from "../components/Polotno/store";
import { ref } from "firebase/database";
import { initializeApp } from "firebase/app";
import { getDatabase, onValue, remove } from "firebase/database";
import { getAuth, signInWithCustomToken } from "firebase/auth";
import mainStore from "../MainStore/store";
// export const BASE_API_ADDRESS = "https://brain.predis.ai";
export const BASE_API_ADDRESS = "https://brain.predis.ai"; //TESTING ADDRESS
export const BASE_API_URL = `${BASE_API_ADDRESS}/users`;
// export const BASE_WEBSOCKET_URL = "wss://brain.predis.ai";
export const BASE_WEBSOCKET_URL = "wss://brain.predis.ai"; //TESTINg ADDRESS
export const GET_HEATMAP_CHART_END_POINT = "get_heatmap_chart_data";
export const GET_BAR_CHART_END_POINT = "get_bar_chart_data";
export const GET_PIE_CHART_END_POINT = "get_pie_chart_data";
export const GET_HEATMAP_MEDIATYPE_CHART_END_POINT = "get_post_perf_chart_data";
export const GET_HASHTAGS_DATA = "get_hashtag_chart_data";
export const COMPETITOR_STATUS_SOCKET_ENDPOINT = `${BASE_WEBSOCKET_URL}/ws/twitter/run_competitor_analysis/`;
export const COMPETITOR_SEARCH_ENDPOINT = `${BASE_API_URL}/getMatchingUsers/`;
export const GET_SUNBURST_END_POINT = "get_sunburst_chart_data";
export const GET_CONTENTTHEME_END_POINT = "get_clustering_data";
export const GET_BASICSTATS_END_POINT = "get_basic_stats_data";
export const GET_SAVED_ANALYSES = "getSavedAnalysis";
export const GET_NOTIFICATIONS_END_POINT = `${BASE_WEBSOCKET_URL}/ws/twitter/getNotifications/`;
export const PARAM_USERNAME = localStorage.getItem("useremail");
export const PARAM_SYSTEMUID = localStorage.getItem("system_uid");
export const PARAM_JOBID = localStorage.getItem("job_id");
export const FIREBASE_UID = localStorage.getItem("fbse_uid");
export const PARAM_TIMEZONE = moment.tz.guess();
export const GET_POSTS_END_POINT = "get_posts_data";
export const GET_BEST_PERF_POST_END_POINT = "get_best_perf_posts";
export const GET_SB_POST_END_POINT = "get_sb_category_posts";
export const GET_SB_DATA_MEDIA_TYPE_END_POINT = "get_sb_data_media_type";
export const GET_DASHBOARD_PERFORMANCE = "get_post_perf_dsb";

export const TOOLTIP_SHADOW = "0px 0px 14px 0px rgba(166,166,166,1)";
export const TOOLTIP_STYLE = {
  boxShadow: TOOLTIP_SHADOW,
  padding: "1rem",
  transition: "0.1s all ease-in",
  background: "#ffffff",
  color: "black",
};
export const BOX_SHADOW_VALUE = "0 1px 20px 0 rgb(0 0 0 / 10%)";
export const BORDER_RADIUS_VALUE = "24px";
export const TOOLTIP_STYLE_TRANSFORM = {
  margin: 15,
  ...TOOLTIP_STYLE,
};
export const TONES = [
  { val: "Casual", label: "Casual" },
  { val: "Funny", label: "Funny" },
  { val: "Formal", label: "Formal" },
  { val: "Witty", label: "Witty" },
  { val: "Persuasive", label: "Persuasive" },
  { val: "Empathetic", label: "Empathetic" },
];
export const NORMAL_POST_ARR = [
  {
    title: "BUSINESS POSTS",
    desc: "Posts Suitable To Promote Your Business",
    img: "https://brain.predis.ai/templates_images/62d7fa86986fe1689cf7a796.png",
    id: "business",
  },
  {
    title: "SPECIAL DAY POSTS",
    desc: "Posts To Celebrate Holidays and Festivals",
    img: SpecialDayImg,
    id: "special",
  },
  {
    title: "QUOTES POSTS",
    desc: "Posts With Quotes By Famous People",
    img: "https://brain.predis.ai/templates_images/62de57c74edd9275936d71c2.png",
    id: "quotes",
  },
  {
    title: "E-COM POSTS",
    desc: "Posts To Promote Your E-Com Products",
    img: "https://brain.predis.ai/templates_images/627a24aa907852c8c9b1defd.png",
    id: "ecom",
  },
];
export const CAROUSEL_POST_ARR = [
  {
    title: "BUSINESS POSTS",
    desc: "Posts Suitable To Promote Your Business",
    img: "https://brain.predis.ai/templates_images/62d7fa86986fe1689cf7a796.png",
    id: "business",
  },
  {
    title: "E-COM POSTS",
    desc: "Posts To Promote Your E-Com Products",
    img: "https://brain.predis.ai/templates_images/627a24aa907852c8c9b1defd.png",
    id: "ecom",
  },
];
export const VIDEO_POST_ARR = [
  {
    title: "BUSINESS VIDEO",
    desc: "Reels/Videos Suitable To Promote Your Business",
    img: "https://brain.predis.ai/templates_images/62d7fa86986fe1689cf7a796.png",
    id: "business",
  },
  {
    title: "E-COM VIDEO",
    desc: "Reels/Videos To Promote Your E-Com Products",
    img: "https://brain.predis.ai/templates_images/627a24aa907852c8c9b1defd.png",
    id: "ecom",
  },
];
export const EDIT_TABS_ARR = [
  {
    label: "Creatives",
    index: 0,
  },
  {
    label: "Captions",
    index: 1,
  },
  {
    label: "Hashtags",
    index: 2,
  },
  {
    label: "Suggestions",
    index: 3,
  },
];
export const SYSTEM_DATETIME_FORMAT = "YYYY-MM-DD HH:mm:00";
export const DISCRETE_CHARTS_COLORS_1 = ["#16a085", "#2980b9", "#fa4d56", "#8e44ad", "#f39c12"];
export const DISCRETE_CHARTS_COLORS_2 = ["#08bdba", "#fa4d56", "#a56eff", "#33b1ff", "#f1c21b"];
export const SEQUENTIAL_CHARTS_COLORS_1 = ["#FFFFFF", "#009d9a"];

export const COLOR_MUTED = "#9e9e9e";
export const COLOR_SUCCESS = "#28A745";
export const COLOR_PRIMARY = "#296bd6";
export const COLOR_DANGER = "#dc3545";
export const COLOR_FACEBOOK = "#4267b2";
export const COLOR_INSTAGRAM = "#e1306c";
export const COLOR_LINKEDIN = "#0077b5";
export const LANGUAGE_LIST = [
  { value: "malay", label: "Bahasa Melayu" },
  { value: "chinese (traditional)", label: "Chinese (Traditional)" },
  { value: "croatian", label: "Croatian" },
  { value: "english", label: "English" },
  { value: "dutch", label: "Dutch" },
  { value: "indonesian", label: "Indonesian" },
  { value: "vietnamese", label: "Vietnamese" },
  { value: "portuguese_br", label: "Portuguese BR" },
  { value: "finnish", label: "Finnish" },
  { value: "french", label: "French" },
  { value: "german", label: "German" },
  { value: "italian", label: "Italian" },
  { value: "norwegian", label: "Norwegian" },
  { value: "polish", label: "Polish" },
  { value: "romanian", label: "Romanian" },
  { value: "czech", label: "Czech" },
  { value: "spanish", label: "Spanish" },
  { value: "swedish", label: "Swedish" },
].sort((a, b) => {
  if (a.value > b.value) {
    return 1;
  } else {
    return -1;
  }
});
export function downloadFile(urlToSend: string, return_func: Function) {
  var req = new XMLHttpRequest();
  req.open("GET", urlToSend, true);
  req.responseType = "blob";
  req.onload = function (event) {
    if ((event.target as XMLHttpRequest).status == 200) {
      var blob = req.response;
      var fileName = req.getResponseHeader("content-disposition"); //if you have the fileName header available
      fileName = (fileName as string).trim().split("=")[1];
      var link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = fileName;
      link.click();
      return_func(true);
    } else {
      return_func(false);
    }
  };

  req.send();
}

export const COMP_TOUR_STEPS = [
  {
    target: ".tour-step-0",
    content: "Check your Selected Handle’s Top Metrics here.",
    title: "Welcome!",
    placement: "left",
    disableBeacon: false,
  },
  {
    target: ".tour-step-1",
    content: "Change the Date Range to Filter Posts.",
    placement: "auto",
  },
  {
    target: ".tour-step-2",
    content: "This shows the different Content Categories used by this handle.",
    placement: "auto",
  },
  {
    target: ".tour-step-3",
    content: "Check Content Patterns according to each Post type.",
    placement: "auto",
  },
  {
    target: ".tour-step-4",
    content: "Click here to explore different Content themes published by the handle.",
    placement: "auto",
    spotlightClicks: true,
  },
  {
    target: ".tour-step-5",
    content:
      "Shows Different Content Themes used by the handle and the engagement of each group. Hint - Sort to See the best performing theme!",
    placement: "auto",
  },
  {
    target: ".tour-step-6",
    content: "Click here to explore different Hashtag analysis published by the handle.",
    placement: "auto",
    spotlightClicks: true,
  },
  {
    target: ".tour-step-7",
    content: "Check the Most used Hashtag Sets detected by Predis.ai",
    placement: "auto",
  },
  {
    target: ".tour-step-8",
    content: "Click here to explore this handle's Post Analytics.",
    placement: "auto",
    spotlightClicks: true,
  },
  {
    target: ".tour-step-9",
    content: "Check the different post types published by the handle.",
    placement: "auto",
  },
  {
    target: ".tour-step-10",
    content: "Check the Engagement Activity of published posts here.",
    placement: "auto",
  },
  {
    target: ".tour-step-11",
    content: "Here are the top 5 best performing posts of the handle.",
    placement: "auto",
    scrollToFirstStep: true,
  },
];

export async function log_segment_event(
  type: string,
  properties: object,
  event: string = "",
  page_name: string = ""
) {
  let payload = {
    user_id: PARAM_USERNAME,
    type: type,
    properties: JSON.stringify(properties),
    event: event,
    page_name: page_name,
  };
  let sendPayload = new FormData();
  await axios
    .post(BASE_API_ADDRESS + "/users/log_event/", payload, {
      headers: { "Content-Type": "multipart/form-data" },
    })
    .then((res) => {});
}
export const PATH_QUERY = new URLSearchParams(window.location.search);

// POLOTNO SAVING
async function getImgb64(img_json: any, callback: Function) {
  let page_ids = img_json.pages.map((pg: any) => {
    return pg.id;
  });
  let b64_imgs = page_ids.map((curr_page_id: string) => {
    let data = store.toDataURL({ pageId: curr_page_id });
    return data;
  });
  Promise.all(b64_imgs)
    .then((data) => {
      callback(data);
    })
    .catch((reson) => {
      //  console.log("reson", reson)
    });
}

export const saveMyTemplate = (cb: Function, mode: string = "tab") => {
  const { username, systemUid, jobId } = mainStore.getState().globalReducer;

  let store_json = store.toJSON();
  getImgb64(store_json, function (img_data: string) {
    if (mode === "tab") {
      cb();
    }

    //storing json also

    const client = new WebSocket("wss://brain.predis.ai/ws/twitter/upload_image/");
    var search_params = new URLSearchParams(window.location.search);
    var resp_data;

    let json = {
      username: username,
      system_uid: systemUid,
      event_id: mainStore.getState().getPosts.currentPostId,
      image_id: mainStore.getState().getPosts.activeImageId,
      custom_template: false, //
      job_id: jobId,
      is_public: false,
      image_b64: mainStore.getState().getPosts.mediaType === "video" ? null : img_data,
      image_json: store_json,
    };

    client.onopen = () => {
      client.send(JSON.stringify(json));
    };
    client.onmessage = (message) => {
      var data = JSON.parse(message.data);
      resp_data = data;
      if (data["finished"]) {
        localStorage.setItem("custom_template_id", data["template_id"]);
        let new_urls = data["url"].map((curr_url: string) => {
          return curr_url + "?v=" + +new Date();
        });
        localStorage.setItem(
          "edited_images",
          JSON.stringify({ url: new_urls, media_type: data["media_type"] })
        );
        if (data["media_type"] === "carousel") {
          mainStore.dispatch({
            type: "getPosts/updateCreativeDetails",
            payload: new_urls,
            event_id: json.event_id,
            mode: "carousel",
          });
        } else if (data["media_type"] === "video") {
          mainStore.dispatch({
            type: "getPosts/updateCreativeDetails",
            payload: data["url"][0],
            thumb_url: data["thumb_url"],
            event_id: json.event_id,
            mode: "video",
          });
        } else {
          mainStore.dispatch({
            type: "getPosts/updateCreativeDetails",
            payload: new_urls,
            event_id: json.event_id,
            mode: "single_image",
          });
        }
        client.close(1000);
      }
    };

    client.onclose = (message) => {
      if (message.code === 1000) {
        if (mode != "tab") {
          cb();
        }
        //saving and closing
        localStorage.setItem("custom_template", "false");
        localStorage.setItem("is_public", "false");
      }
    };
  });
};

export const EDIT_POST_TOUR_STEPS = [
  {
    target: ".edit-tour-step-0",
    content: "This is the Creative Editor",
    placement: "auto",
    disableBeacon: true,
  },
  {
    target: ".edit-tour-step-1",
    content: "Use these to edit the creative.",
    placement: "auto",
  },
  {
    target: ".edit-tour-step-2",
    content: "Generate more Captions here.",
    placement: "auto",
  },
  {
    target: ".edit-tour-step-3",
    content: "Select hashtags from here.",
    placement: "auto",
  },
  {
    target: ".edit-tour-step-4",
    content: "Get AI-Suggestions to improve your post.",
    placement: "auto",
  },
  {
    target: ".edit-tour-step-5",
    content: "Go back to the Library from here.",
    placement: "auto",
  },
];

export const FIREBASE_CONFIG = {
  apiKey: "AIzaSyAzX-jeeVITX7BFDWyjxmqNGT-SU0zLwyg",
  authDomain: "fiery-nimbus-261705.firebaseapp.com",
  databaseURL: "https://fiery-nimbus-261705-default-rtdb.firebaseio.com",
  projectId: "fiery-nimbus-261705",
  storageBucket: "fiery-nimbus-261705.appspot.com",
  messagingSenderId: "295142708",
  appId: "1:295142708:web:a2303b0f515d04fdb35161",
  measurementId: "G-4ESYT0F1HQ",
};

const getFirebaseToken = () => {
  const { username, systemUid } = mainStore.getState().globalReducer;
  const sendData = new URLSearchParams({
    username: username,
    system_uid: systemUid,
  });
  return axios.get(`get_fbse_ct/?${sendData}`);
};

export const GET_FIREBASE_APP = () => {
  const app = initializeApp(FIREBASE_CONFIG);
  const auth = getAuth(app);
  if (!auth.currentUser) {
    // TODO: Optimize This Later
    signInWithCustomToken(auth, localStorage.getItem("fbse_token"))
      .then(
        //localStorage.getItem("fbse_token")
        (userCredentials) => {
          mainStore.dispatch({ type: "setFirebaseUID", payload: userCredentials.user.uid });
        }
      )
      .catch((err) => {
        // const errCode = err.code;
        // if(errCode==="auth/invalid-custom-token"){
        getFirebaseToken().then((res) => {
          signInWithCustomToken(auth, res.data.token).then((userCredentials) => {
            mainStore.dispatch({ type: "setFirebaseUID", payload: userCredentials.user.uid });
          });
        });
        // }
      });
  }
  return app;
};

export const FIREBASE_APP = null;
//  GET_FIREBASE_APP();

export const GET_FIREBASE_REF = (evId: string, imgId: string) => {
  const app = FIREBASE_APP;
  // const app = JSON.parse(localStorage.getItem("fbApp"));
  const auth = getAuth(app);
  // UNCOMMENT FOR TESTING ONLY
  // signInWithCustomToken(auth,localStorage.getItem("fbse_token")).then((userCredentials)=>{
  //   // console.log("userCredentials", userCredentials.user)
  // })
  const currentStates = mainStore.getState().globalReducer;
  const database = getDatabase(app);
  return ref(
    database,
    "generated_posts/" +
      `${currentStates.firebaseUid}/` +
      `${currentStates.jobId}/` +
      `${evId}/` +
      `${imgId}/`
  );
};
interface FirebaseCallback {
  //THIS FUNCTION WILL TAKE AND RETURN STATUS AND OPTIONALLY URL
  (status: string, url?: string, thumb_url?: string): { status: string; url?: string };
}
export const PREVIEW_FIRE_LISTEN = (evId: string, imgId: string, cb: any) => {
  let dbRef = GET_FIREBASE_REF(evId, imgId);
  onValue(dbRef, (snapshot) => {
    const data = snapshot.val();
    cb(data.status);
  });
};
export const PREVIEW_FIRE_DELETE = (evId: string, imgId: string) => {
  let dbRef = GET_FIREBASE_REF(evId, imgId);
  remove(dbRef).then((res) => {
    return true;
  });
};
export const GET_PERCENTAGE = (numb: number, total: number) => {
  return (numb / total) * 100;
};
export const GET_ACTUAL_OF_PERCENTAGE = (numb: number, total: number) => {
  return (numb / 100) * total;
};

export const FOREVER_FREE_ID = "forever_free";
